import { render } from "./SPhorizondal.vue?vue&type=template&id=d195e302&scoped=true"
import script from "./SPhorizondal.vue?vue&type=script&lang=js"
export * from "./SPhorizondal.vue?vue&type=script&lang=js"

import "./SPhorizondal.vue?vue&type=style&index=0&id=d195e302&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d195e302"]])

export default __exports__